import React from "react";
import "./PartnersStyle.css";
import DrTurkiBakhsh from "../../assets/Partner/DrTurkiBakhsh.png";
import DrDhaif from "../../assets/Partner/DrDhaif.jpeg";
import dentex from "../../assets/Partner/dentex-logo.png";
import white from "../../assets/Partner/white.jpg";
import DrMeshal from "../../assets/Partner/DrMeshal.png";
import DrEslamElKordy from "../../assets/Partner/DrEslamElKordy.png";
import DROmarRagab from "../../assets/Partner/DROmarRagab.png";
import EliteDoctors from "../../assets/Partner/EliteDoctors.png";
import DROsamaBasri from "../../assets/Partner/DROsamaBasri.png";
import angle from "../../assets/Partner/angle.png";
import DrAmira from "../../assets/Partner/DrAmira.jpeg";
import DrYasser from "../../assets/Partner/DrYasser.png";
import DrRasha from "../../assets/Partner/DrRasha.png";
import ahmed from "../../assets/Partner/ahmedLotfy.png";
import { useTranslation } from "react-i18next";

const Partners = ({ id }) => {
  const { t, i18n } = useTranslation();

  const partners = [
    { name: "Dr.Turki Bakhsh", image: DrTurkiBakhsh },
    { name: "Dr.Daif", image: DrDhaif },
    { name: "Dentix Team", image: dentex },
    { name: "Dr.Mohamed El-Ostaz", image: white },
    { name: "Dr.Meshal", image: DrMeshal },
    { name: "Dr.Omar Ragab", image: DROmarRagab },
    { name: "Dr.Eslam El-Kordy", image: DrEslamElKordy },
    { name: "Elite Doctors", image: EliteDoctors },
    { name: "Dr.Osama Basri", image: DROsamaBasri },
    { name: "Angel Aligner", image: angle },
    { name: "Dr Amira", image: DrAmira },
    { name: "Dr Yasser", image: DrYasser },
    { name: "Dr Rasha", image: DrRasha },
    { name: "Ahmed Lotfy", image: ahmed },
  ];

  return (
    <section
      className={`partners-container ${i18n.dir() === "rtl" ? "rtl" : ""}`}
      id={id}
    >
      <h2 className="partners-title">{t("partners.title")}</h2>
      <div className="partners-strip">
        <div className="partners-list" aria-hidden="true">
          {partners.concat(partners).map((partner, index) => (
            <div key={index} className="partner-item">
              <img
                src={partner.image}
                alt={partner.name}
                className="partner-image"
                loading="lazy"
              />
              <p className="partner-name">{partner.name}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Partners;
